"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.tdpTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.tdpTemplates = [
    {
        id: "non-sso-tab-default-bot-ts",
        name: templateNames_1.TemplateNames.TabAndDefaultBot,
        language: "typescript",
        description: "",
    },
    {
        id: "non-sso-tab-default-bot-js",
        name: templateNames_1.TemplateNames.TabAndDefaultBot,
        language: "javascript",
        description: "",
    },
    {
        id: "default-bot-message-extension-ts",
        name: templateNames_1.TemplateNames.BotAndMessageExtension,
        language: "typescript",
        description: "",
    },
    {
        id: "default-bot-message-extension-js",
        name: templateNames_1.TemplateNames.BotAndMessageExtension,
        language: "javascript",
        description: "",
    },
    {
        id: "message-extension-ts",
        name: templateNames_1.TemplateNames.MessageExtension,
        language: "typescript",
        description: "",
    },
    {
        id: "message-extension-js",
        name: templateNames_1.TemplateNames.MessageExtension,
        language: "javascript",
        description: "",
    },
    {
        id: "message-extension-csharp",
        name: templateNames_1.TemplateNames.MessageExtension,
        language: "csharp",
        description: "",
    },
];
//# sourceMappingURL=tdp.js.map